/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Lastmodifieddate2Inputs */

const id_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Dimodifikasi`)
};

const ms_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Diubah Suai`)
};

const da_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringsdato`)
};

const de_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsdatum`)
};

const en_us2_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified Date`)
};

const es_es2_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de modificación`)
};

const es_mx2_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de modificación`)
};

const fil_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Pagbabago`)
};

const fr_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de modification`)
};

const it_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modifica`)
};

const hu_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módosítás dátuma`)
};

const nl_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingsdatum`)
};

const no_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringsdato`)
};

const pl_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modyfikacji`)
};

const pt_br2_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de modificação`)
};

const pt_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de modificação`)
};

const ro_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modificării`)
};

const fi_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkauspäivä`)
};

const sv_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringsdatum`)
};

const vi_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sửa đổi`)
};

const tr_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştirilme Tarihi`)
};

const cs_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum změny`)
};

const bg_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на промяна`)
};

const ru_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата изменения`)
};

const uk_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата зміни`)
};

const ar_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ التعديل`)
};

const hi_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संशोधित तारीख़`)
};

const th_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่แก้ไข`)
};

const ja_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日`)
};

const zh_cn2_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改日期`)
};

const zh_hant1_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改日期`)
};

const ko_search_sort_lastmodifieddate2 = /** @type {(inputs: Search_Sort_Lastmodifieddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정일`)
};

/**
* | output |
* | --- |
* | "Modified Date" |
*
* @param {Search_Sort_Lastmodifieddate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_lastmodifieddate2 = /** @type {((inputs?: Search_Sort_Lastmodifieddate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Lastmodifieddate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_lastmodifieddate2(inputs)
	if (locale === "ms") return ms_search_sort_lastmodifieddate2(inputs)
	if (locale === "da") return da_search_sort_lastmodifieddate2(inputs)
	if (locale === "de") return de_search_sort_lastmodifieddate2(inputs)
	if (locale === "en-US") return en_us2_search_sort_lastmodifieddate2(inputs)
	if (locale === "es-ES") return es_es2_search_sort_lastmodifieddate2(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_lastmodifieddate2(inputs)
	if (locale === "fil") return fil_search_sort_lastmodifieddate2(inputs)
	if (locale === "fr") return fr_search_sort_lastmodifieddate2(inputs)
	if (locale === "it") return it_search_sort_lastmodifieddate2(inputs)
	if (locale === "hu") return hu_search_sort_lastmodifieddate2(inputs)
	if (locale === "nl") return nl_search_sort_lastmodifieddate2(inputs)
	if (locale === "no") return no_search_sort_lastmodifieddate2(inputs)
	if (locale === "pl") return pl_search_sort_lastmodifieddate2(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_lastmodifieddate2(inputs)
	if (locale === "pt") return pt_search_sort_lastmodifieddate2(inputs)
	if (locale === "ro") return ro_search_sort_lastmodifieddate2(inputs)
	if (locale === "fi") return fi_search_sort_lastmodifieddate2(inputs)
	if (locale === "sv") return sv_search_sort_lastmodifieddate2(inputs)
	if (locale === "vi") return vi_search_sort_lastmodifieddate2(inputs)
	if (locale === "tr") return tr_search_sort_lastmodifieddate2(inputs)
	if (locale === "cs") return cs_search_sort_lastmodifieddate2(inputs)
	if (locale === "bg") return bg_search_sort_lastmodifieddate2(inputs)
	if (locale === "ru") return ru_search_sort_lastmodifieddate2(inputs)
	if (locale === "uk") return uk_search_sort_lastmodifieddate2(inputs)
	if (locale === "ar") return ar_search_sort_lastmodifieddate2(inputs)
	if (locale === "hi") return hi_search_sort_lastmodifieddate2(inputs)
	if (locale === "th") return th_search_sort_lastmodifieddate2(inputs)
	if (locale === "ja") return ja_search_sort_lastmodifieddate2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_lastmodifieddate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_lastmodifieddate2(inputs)
	return ko_search_sort_lastmodifieddate2(inputs)
});
export { search_sort_lastmodifieddate2 as "search.sort.lastModifiedDate" }